var React = require('react');

function Vihara (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M160 192h64v-64h-64zM96 352h64v-64H96zM64 496a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-48H64zm480-208h-64v64h64zm-32 160v48a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-48zm-224 48a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-48h-64zm192-368h-64v64h64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M160 128h320l27.31-16.3a16 16 0 0 0-4.16-25.62L320 0 136.85 86.07a16 16 0 0 0-4.16 25.62zm472.88 272.71L544 352H96L7.12 400.71a16 16 0 0 0 1.72 27.62L64 448h512l55.15-19.67a16 16 0 0 0 1.73-27.62zm-592-130.4L96 288h448l55.16-17.69a16 16 0 0 0 0-28.62L480 192H160L40.84 241.69a16 16 0 0 0 0 28.62z","className":"fa-primary","key":2})]);
}

Vihara.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Vihara;

Vihara.default = Vihara;
